import styled from 'styled-components';

import { fadeIn } from '../../../styles/shared.style';

export const APP_BAR_HEIGHT = 24;

export const Container = styled.section<{$hideContent: boolean}>`
  display: ${({ $hideContent }) => $hideContent ? 'none' : 'flex'};
  flex-wrap: wrap;
  width: 100vw;
  max-width: 1192px;
  align-items: center;
  justify-content: space-between;
  padding-top: 16px;
  background-color: ${({ theme }) => theme.colors.surface.high};
  
  animation: ease-out, ${fadeIn} 0.2s ease-out;

  @media (max-width: 1200px) {
    position: fixed;
    top: 44px;
    left: 0;
    z-index: 20;
    padding: 16px;
  }
`;

export const BreadCrumbs = styled.section`
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 480px) {
    width: 100%;
    margin-bottom: 20px;
  }
`;

export const ContainerOptions = styled.section`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;

  @media (max-width: 480px) {
    width: 100%;
    justify-content: space-between;
    gap: 0;
  }

`;

export const RowFullWidth = styled.section<{
  $align: 'center' | 'space-between';
}>`
  display: flex;
  justify-content: ${({ $align }) => $align};
  width: 100%;
`;

export const LocaleSelector = styled.section`
  display: flex;
  align-items: center;
  justify-content: center;
`;
